export default __webpack_public_path__ + "static/media/info-icon.d9c7f83c.svg";